import { ColumnsTheme } from '@/components/Columns/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const Columns = GenericSlot({ as: 'div', theme: ColumnsTheme });
